// extracted by mini-css-extract-plugin
export default {"NewsItemContainer":"NewsItemContainer_NewsItemContainer__2uBb8"};